export const API_URL =
  (process.env.REACT_APP_API_URL || "").replace(/\/$/, "") ||
  "http://localhost:8000/api";

// If/when you move to HttpOnly cookie auth, we must send credentials (cookies)
export const API_WITH_CREDENTIALS = true;
